export default class LmsImportErrorDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { dateCreated: json.dateCreated && new Date(json.dateCreated) });
    }
}
